module.exports = __webpack_public_path__ + "e514fd69a5ec96b85110ebe44f49dbcf.svg";